import React, { useEffect, useState } from 'react';
import { RegularButton, Snack, Snackbar, SnackbarProvider, Tooltip, Typography, useSnackbar, } from 'fronton-react';
import { BookmarkSimpleIcon, CheckCircleIcon } from '@fronton/icons-react';
import styles from './styles.module.css';
export const WishlistCheckboxWithLogic = ({ text, productId, onChange, isInteractive, size, hasText = false, isDesktop = true, isChecked = false, }) => {
    const [mounted, setMounted] = useState(false);
    const { state, addSnack } = useSnackbar();
    const [inWishlist, setInWishlist] = useState(isChecked);
    const changeHandler = () => {
        setInWishlist(prev => {
            const nextValue = !prev;
            onChange(productId, nextValue ? 1 : -1);
            if (nextValue) {
                addSnack({ id: productId, title: text.snackAdd });
            }
            return nextValue;
        });
    };
    const tipText = inWishlist ? text.tooltipRemove : text.tooltipAdd;
    const button = (React.createElement(RegularButton, { "data-qa": "wishlist-button", withExtraClickZone: true, label: tipText, size: size, onClick: changeHandler, variant: "pseudo", className: [
            styles.inListButton,
            !hasText && styles.reset,
            !isInteractive && styles.noninteractive,
            inWishlist && styles.inListButtonActive,
        ]
            .filter(Boolean)
            .join(' ')
            .trim(), iconLeft: React.createElement(BookmarkSimpleIcon, { "data-qa": inWishlist ? 'bookmark-icon-set' : 'bookmark-icon-not-set', type: "outline", size: size, color: "text-primary" }) },
        React.createElement(Typography, { size: "body_long", variant: "s", color: "text-primary", className: styles.wishlistText },
            hasText && !inWishlist && text.wishlistAdd,
            hasText && inWishlist && text.wishlistAdded)));
    useEffect(() => {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        isDesktop ? (React.createElement(Tooltip, { placement: "top", title: tipText }, button)) : (React.createElement(React.Fragment, null, button)),
        React.createElement(Snackbar, { verticalPosition: "bottom" }, state.map(({ id, title }) => (React.createElement(Snack, { key: id, id: id, header: title, icon: React.createElement(CheckCircleIcon, { type: "outline", size: "l", color: "text-primary" }), variant: "neutral", autoHideTimer: 3000 }))))));
};
export const WishlistCheckbox = ({ ...props }) => (React.createElement(SnackbarProvider, null,
    React.createElement(WishlistCheckboxWithLogic, { ...props })));
//# sourceMappingURL=wishlist-checkbox.js.map